import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import moment from 'moment';

@Model()
export default class BusTrip extends ApplicationRecord {
  static jsonapiType = 'bus-trips';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Timetable',
        value: 'service',
      },
      {
        text: 'Bus Leaves',
        value: 'departureTime',
      },
    ];
  }

  static scopeFactory() {
    return BusTrip.includes([]);
  }

  @Attr() service: string;
  @Attr() departureTime: string;

  get formattedTime() {
    if (!this.departureTime) {
      return;
    }
    return moment(this.departureTime, 'HH:mm:ss').format('h:mm a');
  }

  get formattedService() {
    if (!this.service) {
      return;
    }

    return this.service.charAt(0).toUpperCase() + this.service.slice(1);
  }
}
